<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import ClientListItem from './components/ClientListItem';
import NewClientDialog from './components/NewClientDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'ClientList',
  components: {
    ClientListItem,
    NewClientDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [
        { text: 'Einloggen', value: 'Einloggen' },
        { text: 'Bezeichnung', value: 'name' },
        { text: 'Demo', value: 'isDemo' },
        { text: 'Verbleibender Testzeitraum', value: 'demoExpirationDate' },
        { text: 'Aktiv', value: 'isActive' },
        { text: 'Reseller User', value: 'resellerUser' },
        { text: 'Aktionen', value: '' }],
      showNewClientDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      clientToDelete: {},
    };
  },
  computed: {
    ...mapState(['clientList']),
    ...mapState('clientList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('clientList', { fetchData: 'fetchClientList' }),
    ...mapActions('clientDetails', ['deleteClient']),
    onDelete(clientToDelete) {
      this.clientToDelete = clientToDelete;
      this.confirmDeletionMessage = `Soll der Mandant ${this.clientToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteClient(this.clientToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
  },
};
</script>

<template>
  <div class="client-list">
    <template v-if="clientList.hasError">
      <p class="js-error-template ma-3">Failed to fetch client list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewClientDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Neu</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        v-if="clientList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="clientList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="clientList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <client-list-item :client="props.item" :expanded="props.expanded" @delete="onDelete" />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewClientDialog
      v-if="showNewClientDialog"
      @cancel="showNewClientDialog = false"
    />

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </div>
</template>


<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
